import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { ICommonDropdownService } from '../ui-lib/common-dropdawn/typing/common-dropdown-service.interface';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { IItem } from '../typing/item.interface';
import { ItemService } from './items.service';

@Injectable({
    providedIn: 'root',
})
export class ItemSelectorService implements ICommonDropdownService {
    additionalParams: Params = {};

    constructor(private itemService: ItemService) {}

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return this.itemService.getItems({ ...query, ...this.additionalParams }).pipe(map(response => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<IItem>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(item => ({
            label: item.name,
            value: item.id,
            tooltip: this.getTooltip(item),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.itemService.getItem(Number(optionValue)).pipe(
            filter(item => !!item),
            map(item => ({
                label: item.name as string,
                value: item.id as number,
                tooltip: '',
            })),
        );
    }

    getTooltip(value: IItem): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '') ;
    }
}
